import React, { PropsWithChildren } from 'react';
import { Container, Divider, Stack } from '@fiverr-private/layout_components';

type WizardFooterProps = PropsWithChildren<{}>;

export const WizardFooter = ({ children }: WizardFooterProps) => (
    <Container width="100%">
        <Divider />
        <Stack
            marginLeft="auto"
            direction="row"
            justifyContent="spaceBetween"
            width={{
                default: '100%',
                sm: 'initial',
            }}
            paddingX={{
                default: '6',
                sm: '10',
            }}
            paddingY={{
                default: '4',
                sm: '6',
            }}
        >
            {children}
        </Stack>
    </Container>
);

WizardFooter.displayName = 'WizardFooter';
